import React from 'react';
import { type Person } from 'talent_matching/types';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import BaseResumeDetailsCell from 'talent_matching/components/shared/base_resume_details_cell';

type Props = {
  candidate: Person;
};

const ResumeDetailsCell = ({ candidate }: Props) => {
  const { setActiveSidePanelTab } = useTalentMatchingTabContext();

  const resume = candidate.resume;
  const employments = resume?.details?.employments || [];

  return (
    <BaseResumeDetailsCell
      employments={employments}
      parsingStatus={resume?.parsing_status}
      resumeExists={!!resume}
      onShowMore={() => setActiveSidePanelTab('resume')}
    />
  );
};

export default ResumeDetailsCell;
